var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 520,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form",
        { attrs: { form: _vm.form } },
        [
          _c(
            "a-form-item",
            {
              attrs: {
                label: "档口名称",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: [
                      "name",
                      {
                        rules: [{ required: true, message: "请输入档口名称" }],
                      },
                    ],
                    expression:
                      "['name', { rules: [{ required: true, message: '请输入档口名称' }] }]",
                  },
                ],
                attrs: { placeholder: "如：热菜档 / 凉菜档 / 主食档" },
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "厨房联打印机",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c(
                "a-select",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: ["printerId"],
                      expression: "['printerId']",
                    },
                  ],
                  attrs: {
                    placeholder: "选择打印机（留空则该档口不出厨房联）",
                    "allow-clear": "",
                  },
                },
                _vm._l(_vm.printers, function (p) {
                  return _c(
                    "a-select-option",
                    { key: p.id, attrs: { value: p.id } },
                    [_vm._v(_vm._s(p.name))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "拆单粒度",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c(
                "a-radio-group",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: ["granularity", { initialValue: "per_order" }],
                      expression:
                        "['granularity', { initialValue: 'per_order' }]",
                    },
                  ],
                },
                [
                  _c("a-radio", { attrs: { value: "per_order" } }, [
                    _vm._v("整单（按档口拆，每单一票）"),
                  ]),
                  _c("a-radio", { attrs: { value: "per_item" } }, [
                    _vm._v("单菜（每菜一票）"),
                  ]),
                  _c("a-radio", { attrs: { value: "per_category" } }, [
                    _vm._v("分类（按菜品分类一票）"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "同款合并",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c("a-switch", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: [
                      "mergeSame",
                      { valuePropName: "checked", initialValue: true },
                    ],
                    expression:
                      "['mergeSame', { valuePropName: 'checked', initialValue: true }]",
                  },
                ],
              }),
              _c(
                "span",
                { staticStyle: { "margin-left": "8px", color: "#999" } },
                [_vm._v("同一单内同菜品+同做法合并数量")]
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "排序",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c("a-input-number", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["sort", { initialValue: 0 }],
                    expression: "['sort', { initialValue: 0 }]",
                  },
                ],
                staticStyle: { width: "120px" },
                attrs: { min: 0, max: 999 },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }